import { IBaseConfig } from "@models/form/base-config";
import { AdministrationEndpoints } from "@dmms/shared/data-access/administration/types/administration-endpoints";
import { ClientTypeEnum } from "@models/core/client-type";
import {
  HardFormFieldTypeEnum,
  IHardFormField,
  IHardFormSelectParams,
} from "@hardcode-kz/ui";
import { PathIcons } from "@static/icons/path-icons";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { LangEnum } from "@models/interface-management/localization";
import { IMenuItemBySlugModel, IMenuItemModel } from "@models/core/menu";
import { Validators } from "@angular/forms";

export class MenuItemConfig implements IBaseConfig {
  version = 1;

  fields: IHardFormField[] = [
    { name: "id" },
    { name: "menuId" },
    { name: "slug" },
    {
      name: "name",
      params: {
        direction: "column",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU],
        ),
      },
    },
    {
      params: {
        direction: "row",
        templateColumns: "2fr 1fr",
        fields: [
          {
            name: "url",
            title: "dicTable.resourceSingleLocator",
            type: HardFormFieldTypeEnum.Input,
            params: {
              validators: [Validators.required],
            },
          },
          {
            name: "weight",
            title: "dicTable.weight",
            type: HardFormFieldTypeEnum.Number,
            params: {
              validators: [Validators.required],
            },
          },
        ],
      },
    },
    {
      name: "parent",
      title: "dicTable.parent",
      type: HardFormFieldTypeEnum.DictionaryTree,
      params: {
        dicType: "api/v1/" + AdministrationEndpoints.MenuItem,
        iconField: "icon",
        queryParams: {
          clientType: ClientTypeEnum.WebClient,
        },
        parent: [{ name: "slug" }],
        dataCallback: (
          items: IMenuItemBySlugModel[],
          value: IMenuItemModel,
        ) => {
          return items.filter(
            (item: IMenuItemBySlugModel) => item.id !== value?.id,
          );
        },
      } as IHardFormSelectParams,
    },
    {
      name: "appPermissions",
      title: "dicTable.permissions",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/" + AdministrationEndpoints.UserPermission,
        multiple: true,
        fieldNames: ["description"],
        fieldValue: "value",
      },
    } as IHardFormField<IHardFormSelectParams>,
    {
      name: "roles",
      title: "dicTable.roles",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/" + AdministrationEndpoints.Roles,
        multiple: true,
      },
    } as IHardFormField<IHardFormSelectParams>,
    {
      name: "isWebShow",
      title: "dicTable.webShow",
      type: HardFormFieldTypeEnum.Checkbox,
      value: true,
    },
    {
      name: "isMobileShow",
      title: "dicTable.mobileShow",
      type: HardFormFieldTypeEnum.Checkbox,
      value: true,
    },
    {
      name: "icon",
      title: "dicTable.icon",
      type: HardFormFieldTypeEnum.Icon,
      params: {
        dicType: PathIcons,
      },
    } as IHardFormField<IHardFormSelectParams>,
  ];

  saveCallback = (data: IMenuItemModel) => {
    data.appPermissions =
      data.appPermissions?.map((permission: any) => permission.value) || [];

    data.roles = data.roles?.map((item) => item?.id);

    data.parentId = data.parent?.id || null;

    delete data.parent;

    return data;
  };
}
